var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card background--white"},[(_vm.hasTitle)?_c('div',{class:[
            'card__title card--padding color--dark capitalize',
            { 'card__title--margin': _vm.addMargins }
        ]},[_vm._t("card__title")],2):_vm._e(),_c('div',{class:[
            'card__body position--relative',
            { 'card--padding': _vm.addMargins },
            { 'card--body-full-height': _vm.bodyFullHeight } ]},[_vm._t("card__body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }